export const API_BASE = process.env.REACT_APP_API_BASE || "";
export const AUTH_STORAGE_KEY = "event_app_auth";
